<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :disabledSave="disabled"
        :icon="icon" 
        v-bind:show.sync="dialog"
        maxWidth="50%"
        textButtonSave="Salvar Cenário"
    >
        <template v-slot:form>
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <s-text-field 
                                autofocus dense 
                                :error-messages="errors.name" 
                                v-model="model.name" 
                                label="Nome*"
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <sys-select-dynamic-division-type
                                :model.sync="model.dynamic_division_type_id"
                                :error="errors.length > 0"  
                                :errors="errors.dynamic_division_type_id"
                                label="Origem Limite de Alunos"
                                dense
                                show-description
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <sys-select-shift
                                :model.sync="model.shifts"
                                :error="errors.length > 0"  
                                :errors="errors.shifts"
                                label="Turno*"
                                dense
                                multiple
                                select-all
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <sys-select-campus
                                :model.sync="model.campuses"
                                :error="errors.length > 0"  
                                :errors="errors.campuses"
                                label="Campus*"
                                multiple
                                dense
                                select-all
                                only-active
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <sys-select-course
                                :model.sync="model.courses"
                                :error="errors.length > 0"  
                                :errors="errors.courses"
                                label="Curso"
                                multiple
                                dense
                                select-all
                                only-active
                                :shifts="model.shifts"
                                :campus-id="model.campuses ?  model.campuses.map(c => c.id).join(',') : null"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="model.consider_students_forecast" 
                                text-helper='Considerar previsão de alunos ao invés do número de alunos confirmados' 
                                inset 
                                label="Previsão de Alunos"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <s-text-field
                                v-model="model.students_limit"
                                :disabled="model.dynamic_division_type_id != 6"
                                :error-messages="errors.students_limit" 
                                label="Limite Padrão"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="model.only_grid_not_join" 
                                text-helper='Desconsiderar turmas que possui junção' 
                                inset 
                                label="Turma sem junção"
                            />
                        </v-col>
                         <v-col cols="12" sm="6">
                             <s-switch 
                                v-model="model.equalize_students" 
                                text-helper='Equalizar número de alunos' 
                                inset 
                                label="Equalizar alunos"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                             <v-select
                                v-model="model.calculation_type_capacity"
                                :disabled="![2,3].includes(model.dynamic_division_type_id)"
                                :items="calculationTypes"
                                label="Cálculo da Capacidade"
                                item-value="id"
                                item-text="name"
                            />
                        </v-col>
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterDynamicDivisionRegister",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        disabled: false,
        calculationTypes: [
            { id: 'avg', name: 'Média' },
            { id: 'min', name: 'Mínimo' },
            { id: 'max', name: 'Máximo' },
        ]
    }),
    created() {
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                
                this.error = false;
                this.errors = {};
                this.disabled = false;
                
                if(!this.model.id){
                    this.model.name = 'Nova Divisão';
                    this.model.dynamic_division_status_id = 1;
                    this.model.dynamic_division_type_id = 1;
                    this.model.students_limit = null;
                }
            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-puzzle-outline"
        },
        title: {
            type: String,
            default: "Divisão Dinâmica"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('dynamicGeneration', ['ActionUpdateDynamicDivision', 'ActionCreateDynamicDivision']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            let payload = {};
            Object.assign(payload, this.model);

            if(payload.campuses && payload.campuses.length > 0){
                payload.campuses = payload.campuses.map(c => ({ id: c.id }));
            }

            if(payload.courses && payload.courses.length > 0){
                payload.courses = payload.courses.map(c => ({ id: c.id }));
            }

            if(edit) {
                this.ActionUpdateDynamicDivision(payload)
                .then((res) => {
                    this.message = res.message ? res.message : '';
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message ? error.message : '';
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateDynamicDivision(payload)
                .then((res) => {
                     this.message = res.message ? res.message : '';
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message ? error.message : '';
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>